<template>
  <div>
      <reset-password/>
  </div>
</template>

<script>
import resetPassword from "@/components/resetPassword/ResetPassword.vue"
export default {
  components: { resetPassword },

}
</script>

<style>

</style>